import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

// Utils

// Components
// @ts-ignore
import { Box, Button } from '@zolteam/zol-admin-ui';
// @ts-ignore
import { Form, FormElements } from '@zolteam/zol-react-form';

// Services
// Schema

// Locales
import fr from '../../locales/fr.json';
import { resetPassword } from '../../services/auth/authService';

const FORM_FORGOT_PASSWORD_NAME = 'resetPassword';

/**
 * Reset Password View
 * @returns {JSX.Element}
 */
function ResetPassword() {
  // Hooks
  const { t } = useTranslation();
  const [success, setSuccess] = useState(false);

  // schema
  const SCHEMA = {
    $schema: 'https://json-schema.org/draft/2020-12/schema',
    type: 'object',
    title: 'Login',
    properties: {
      email: {
        type: 'string',
        format: 'email',
        description: t('resetPassword.fields.email'),
        x_layout: '1/1/1/13',
      },
    },
    required: [
      'email',
    ],
    additionalProperties: false,
  };

  // Services
  const {
    mutate: mutateResetPassword,
    isLoading: isLoadingForgotPassword,
  } = useMutation(resetPassword, {
    onSuccess: () => {
      setSuccess(true);
    },
  });

  // Actions
  /**
   * Submit Form
   * @param {object} data
   * @param {string} data.email
   * @returns {void}
   */
  const onSubmit = (data) => {
    mutateResetPassword({
      ...data,
      returnUrl: `${window.location.origin}/update-password?token=`,
      origin: 'admin',
    });
  };

  return (
    <Box direction="column" gap="m" fullWidth>
      {success ? (
        <>
          <Box direction="column" gap="xs" align="center" fullWidth>
            <h1 className="h3-default font-weight-bold">
              {t('resetPassword.success.title')}
            </h1>
            <span className="p1-default">
              {t('resetPassword.success.description')}
            </span>
          </Box>

          <Box direction="column" gap="xs" align="normal" fullWidth>
            <Button color="noBackground">
              <Link to="/login">
                {t('resetPassword.actions.login')}
              </Link>
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Box direction="column" gap="xs" align="center" fullWidth>
            <h1 className="h3-default font-weight-bold">
              {t('resetPassword.title')}
            </h1>
            <span className="p1-default">
              {t('resetPassword.description')}
            </span>
          </Box>

          <Box fullWidth>
            <Form
              name={FORM_FORGOT_PASSWORD_NAME}
              className=""
              callbacks={{
                onSubmit,
              }}
              schema={SCHEMA}
              translations={{ formValidation: fr.formValidation }}
              defaultValues={{}}
            >
              {
              (formConfig, formInfo) => (
                <FormElements
                  translations={null}
                  formConfig={formConfig}
                  formTitle={formInfo.formName}
                />
              )
}
            </Form>
          </Box>

          <Box direction="column" gap="xs" align="normal" fullWidth>
            <Button
              isSubmit
              form={FORM_FORGOT_PASSWORD_NAME}
              isLoading={isLoadingForgotPassword}
            >
              {t('resetPassword.actions.submit')}
            </Button>

            <Button color="noBackground">
              <Link to="/login">
                {t('resetPassword.actions.login')}
              </Link>
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
}

export default ResetPassword;
